import { ajax } from "../services/ajax";
import { api } from "../constants";

export const getChannelsList = () => ajax.get(api.endpoints.channels.list.all);

export const deleteChannel = (id, type) => ajax.post(api.endpoints.channels.remove[type], { id });

export const getChannel = id => ajax.get(api.endpoints.channels.get(id));